import styled from 'styled-components';

export const LoginWrapper = styled.section`
    font-family: ${({ theme }) => theme.fonts.inter} !important;
    width: 100vw;
    height: 100vh;
    margin: auto;
    position: relative;
    overflow: hidden;
    background: ${({ theme }) => theme.settings.whiteColor};
    padding: 40px;

    @media (max-width: 991.99px) {
        padding: 30px;
    }

    /* Below md breakpoint - mobile/tablet view */
    @media (max-width: 768px) {
        padding: 24px;
        height: 100vh;
        display: flex;
        flex-direction: column;
    }

    @media (max-width: 480px) {
        padding: 16px;
    }

    @media (max-width: 375px) {
        padding: 12px;
    }

    .loginLogo {
        @media (max-width: 768px) {
            flex-shrink: 0;
        }
    }

    .loginBanner {
        width: 100%;
        height: 100%;
        position: relative;

        /* Hide banner on mobile/tablet */
        @media (max-width: 768px) {
            display: none;
        }

        img {
            border-radius: 16px;
            height: calc(100vh - 80px);
            min-height: auto;
            position: absolute;
            object-fit: cover;

            @media (max-width: 991.99px) {
                height: calc(100vh - 60px);
                border-radius: 14px;
            }
        }
    }

    .loginContainer{
        width: 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /* Mobile/tablet - center form vertically */
        @media (max-width: 768px) {
            position: static;
            top: auto;
            left: auto;
            transform: none;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        h1{
            font-family: ${({ theme }) => theme.fonts.inter};
            font-weight: 500;
            font-size: 30px;
            line-height: 36px;
            margin: 60px 0px 20px 0px;

            @media (max-width: 991.99px) {
                font-size: 28px;
                line-height: 34px;
                margin: 50px 0px 18px 0px;
            }

            @media (max-width: 768px) {
                font-size: 26px;
                line-height: 32px;
                margin: 0px 0px 16px 0px;
            }

            @media (max-width: 480px) {
                font-size: 24px;
                line-height: 30px;
                margin: 0px 0px 14px 0px;
            }

            @media (max-width: 375px) {
                font-size: 22px;
                line-height: 28px;
                margin: 0px 0px 12px 0px;
            }
        }

        p{
            font-family: ${({ theme }) => theme.fonts.inter};
            font-weight: 400;
            font-size: 14px;
            line-height: 19px;
            color: #000;
            margin-bottom: 30px;

            @media (max-width: 768px) {
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 24px;
            }

            @media (max-width: 480px) {
                font-size: 13px;
                line-height: 19px;
                margin-bottom: 20px;
            }

            @media (max-width: 375px) {
                font-size: 13px;
                line-height: 18px;
                margin-bottom: 16px;
            }

            a{
                font-weight: 600;
                color: rgba(72, 63, 194, 1);
            }
        }

        .loginBtn {
            @media (max-width: 768px) {
                height: 48px;
                font-size: 15px;
            }

            @media (max-width: 480px) {
                height: 46px;
                font-size: 14px;
            }

            @media (max-width: 375px) {
                height: 44px;
                font-size: 14px;
            }
        }
    }

    .forgotPassword{
        font-family: ${({ theme }) => theme.fonts.inter};
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        color: #000;
        text-decoration: none;

        @media (max-width: 768px) {
            font-size: 14px;
        }

        @media (max-width: 480px) {
            font-size: 13px;
        }

        &:hover{
            color: ${({ theme }) => theme.settings.primary};
        }
    }

    /* Override browser autofill background color */
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px white inset !important;
        -webkit-text-fill-color: #000 !important;
        transition: background-color 5000s ease-in-out 0s;
    }

    /* Responsive form inputs */
    .ant-input,
    .ant-input-password {
        @media (max-width: 768px) {
            font-size: 15px;
        }

        @media (max-width: 480px) {
            font-size: 14px;
        }
    }

    .ant-form-item-label > label {
        @media (max-width: 768px) {
            font-size: 14px;
        }

        @media (max-width: 480px) {
            font-size: 13px;
        }
    }

    /* Row and column adjustments for mobile */
    .ant-row {
        @media (max-width: 768px) {
            margin-left: 0 !important;
            margin-right: 0 !important;
            flex: 1;
            display: flex;
            flex-direction: column;
        }
    }

    .ant-col {
        @media (max-width: 768px) {
            padding-left: 0 !important;
            padding-right: 0 !important;
            flex: none !important;
            max-width: 100% !important;
            width: 100% !important;
        }

        &:first-child {
            @media (max-width: 768px) {
                flex: 1 !important;
                display: flex;
                flex-direction: column;
            }
        }
    }
`;